/**
 * @generated SignedSource<<c4703147c75004d0c5b73959a2b8e86f>>
 * @relayHash 9a6b1b768dc0ce655365a9c20d064f90
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e03eccd6f048973d35ac76ef4e52008c2226f066402af5d4277b0720789bd144

import type { ConcreteRequest } from 'relay-runtime';
export type KnowledgeBaseSourceInput = {
  metadata?: KnowledgeBaseSourceMetadataInput | null;
  sourceARI?: string | null;
  sourceContainerARI?: string | null;
  visibility?: string | null;
};
export type KnowledgeBaseSourceMetadataInput = {
  applicationIdentifier?: string | null;
};
export type useCreateKbSourceLinkingMutationJsmCardMutation$variables = {
  cloudId: string;
  projectIdentifier: string;
  sources: ReadonlyArray<KnowledgeBaseSourceInput>;
};
export type useCreateKbSourceLinkingMutationJsmCardMutation$data = {
  readonly knowledgeBase_linkSources: {
    readonly linkSourceResults: ReadonlyArray<{
      readonly success: boolean | null;
    }> | null;
  } | null;
};
export type useCreateKbSourceLinkingMutationJsmCardMutation = {
  response: useCreateKbSourceLinkingMutationJsmCardMutation$data;
  variables: useCreateKbSourceLinkingMutationJsmCardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIdentifier"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sources"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "projectIdentifier",
        "variableName": "projectIdentifier"
      },
      {
        "kind": "Variable",
        "name": "sources",
        "variableName": "sources"
      }
    ],
    "concreteType": "KnowledgeBaseLinkSourcesResponse",
    "kind": "LinkedField",
    "name": "knowledgeBase_linkSources",
    "plural": false,
    "selections": [
      {
        "concreteType": "KnowledgeBaseLinkSourceResult",
        "kind": "LinkedField",
        "name": "linkSourceResults",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCreateKbSourceLinkingMutationJsmCardMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreateKbSourceLinkingMutationJsmCardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "e03eccd6f048973d35ac76ef4e52008c2226f066402af5d4277b0720789bd144",
    "metadata": {},
    "name": "useCreateKbSourceLinkingMutationJsmCardMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a19124cc7a50e197f97e53d7aaec84fd";

export default node;
